import DSBox from "views/system-design/DSBox";
import DSTypography from "views/system-design/DSTypography";
import DSSecondaryButton from "views/system-design/DSSecondaryButton";

type LoadMoreFooterProps = {
  loadedCount: number;
  total: number;
  hasMore: boolean;
  onLoadMore: () => void;
};

/**
 * Only appears when a result set is too large for the pages a view pulls on its
 * own, so the count on screen never silently misrepresents the filter.
 */
export default function LoadMoreFooter({
  loadedCount,
  total,
  hasMore,
  onLoadMore,
}: LoadMoreFooterProps) {
  if (!hasMore) return null;

  return (
    <DSBox
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        py: 2,
      }}
    >
      <DSTypography variant="body2" sx={{ color: "text.secondary" }}>
        Showing {loadedCount} of {total}
      </DSTypography>
      <DSSecondaryButton size="medium" onClick={onLoadMore}>
        Load more
      </DSSecondaryButton>
    </DSBox>
  );
}
